import * as React from "react";
import * as Loadable from "react-loadable";
import { Loader } from "src/common/components";

export default Loadable({
  loader: () => import("../containers/AnonTeamSummaryPage"),
  loading: () => <Loader />
});
